<template>
  <div class="s-dialog-mask">
    <div class="s-mask"></div>
    <div class="s-dialog">
      <div class="weui-dialog__bd">
        <slot name="bd-content"></slot>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  export default {
    data () {
      return {}
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?72467cee